export const getLocaleForUrl = (locale: string | undefined) => {
  if (locale === 'en' || locale === undefined) return '';
  else return `/${locale}`;
};
